import { emptyArray } from 'ui-components/default-props/empty';
import { MarketplaceIds } from '../enums/marketplace-ids';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const getIsPackingSlipSharing = (storeConfigurations) => {
  return storeConfigurations.some((c) => c.isPackingSlipSharing);
};
const getUniqueStoreGuids = (salesOrders) => {
  return [...new Set(salesOrders ? salesOrders.map((s) => s.store.storeGuid) : emptyArray)];
};
const getAuctaneFulfillmentOrders = (salesOrders) => {
  return salesOrders ? salesOrders?.filter((s) => parseInt(s.store.marketplaceId, 10) === MarketplaceIds.AuctaneFulfillment) : emptyArray;
};

export const useFilteredStoreGuids = (fulfillmentPlanIds) => {
  const salesOrders = useSelector((state) =>
    Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, {
      fulfillmentPlanIds,
    }),
  );
  const storeGuids = getUniqueStoreGuids(salesOrders);
  const auctaneFulfillmentOrders = getAuctaneFulfillmentOrders(salesOrders);
  const auctaneFulfillmentStoreGuids = getUniqueStoreGuids(auctaneFulfillmentOrders);

  return {
    storeGuids,
    auctaneFulfillmentStoreGuids,
    auctaneFulfillmentOrders,
  };
};
